import { useSearchParams } from 'react-router'

/**
 * The `token` query parameter every emailed link carries.
 *
 * Returned as `null` when it is absent or empty, which is a real case rather
 * than a defensive one: people forward these links, mail clients truncate long
 * URLs at the line wrap, and a bare `/verify-email` with no token has to say
 * something better than "that link is not valid".
 *
 * **Nothing here posts on page load.** Every one of these pages redeems from a
 * button press or an explicit effect the page controls, never from rendering,
 * because mail security scanners fetch URLs before a human ever sees them and a
 * single-use token spent by a scanner is a token the user never gets to use.
 * The pages that do redeem automatically (`/verify-email`,
 * `/verify-email-change`) still issue a **POST**, which a scanner following a
 * link does not make.
 */
export function useToken(): string | null {
  const [params] = useSearchParams()
  const token = params.get('token')
  return token && token.length > 0 ? token : null
}
